module.exports = __webpack_public_path__ + "static/gw-4ae6e46ecb5b9162f8f95b047e15e4cc.jpg";